import { connectRouter } from 'connected-react-router'

import { history } from './middleware'

const reducer = connectRouter(history)
export default reducer
